module.exports = __webpack_public_path__ + "static/media/ic_video_close.03fa2caa.svg";